export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5629.65ed3802.jpg";